const windowObject:any = window;

export function trackPageView(path: string) {
    try {
        windowObject['trackPageView'](path);
    } catch (e) {
        console.error("error tracking page view",e)
    }
}

export function trackEvent(action: string, value?: number) {
    try {
        windowObject['trackEvent']( "gameplay" , action, value);
    } catch (e){
        console.error("error tracking page event",e)
    }
}
